module.exports.selectable = ["es", "en", "zh"];

module.exports.orderedLanguageCodes = ["en", "es", "zh"];

module.exports.languages = [
  {code: "en", name: "English", native: "English"},
  {code: "es", name: "Spanish", native: "Español"},
  {code: "zh", name: "Chinese", native: "中文"},
];
